import { formatClock, formatLongDate } from '@/lib/time';
import { useMinuteClock } from '@/lib/useMinuteClock';
import css from './Tray.module.css';

export function Clock() {
  const now = useMinuteClock();

  return (
    <div className={css.clock} title={formatLongDate(now)}>
      {formatClock(now)}
    </div>
  );
}
